import {
  POSSIBlE_CLIENT_ROLES,
  POSSIBLE_OWNER_ROLES,
  POSSIBLE_PRODUCT_SUPPLIER_ROLES,
} from '@/components/EntityCreationModals/UserCreationModal/UserCreationModal.config'
import type { OrganisationInterface } from '@/types'
import { hasRoleFromGroup } from '@/utils/auth/roleGroups'

export type OrganisationUsersTarget = {
  tokenRoles: string[]
  organisation: Partial<Pick<OrganisationInterface, 'roles'>>
  isOwnOrganisation: boolean
}

const SUPERUSER_ROLE = 'SUPERUSER'

const isSupplierStaff = (tokenRoles: string[]) =>
  hasRoleFromGroup(tokenRoles, 'SUPPLIER_STAFF')

const isOwnerOrganisation = ({
  tokenRoles,
  organisation,
  isOwnOrganisation,
}: OrganisationUsersTarget) =>
  !!organisation.roles?.includes('OWNER_ORGANISATION') ||
  (isOwnOrganisation && isSupplierStaff(tokenRoles))

export const canManageOrganisationUsers = (target: OrganisationUsersTarget) => {
  if (isOwnerOrganisation(target)) {
    return hasRoleFromGroup(target.tokenRoles, 'SENIOR_MANAGERS')
  }

  return (
    isSupplierStaff(target.tokenRoles) ||
    (target.isOwnOrganisation && target.tokenRoles.includes(SUPERUSER_ROLE))
  )
}

export const getAssignableRoleOptions = (target: OrganisationUsersTarget) => {
  if (isOwnerOrganisation(target)) return POSSIBLE_OWNER_ROLES

  return target.organisation.roles?.includes('PRODUCT_SUPPLIER_ORGANISATION')
    ? POSSIBLE_PRODUCT_SUPPLIER_ROLES
    : POSSIBlE_CLIENT_ROLES
}
